import type { OMSConfig, StrategyEvaluator, SignalResult, StrategyContext } from '../types';
import { ensureFlatOpts } from '../../analysis/trend-evaluator';

export const evaluateConnectingDotsRSI: StrategyEvaluator = (data: any, currentUnixTime: number, config: OMSConfig, context: StrategyContext): SignalResult | null => {
    if (!data || !context.liveIndicators) return null;

    const { ind0916MinCe, ind0916MaxPe, top1 } = context.liveIndicators;
    if (!ind0916MinCe || !ind0916MaxPe) return null;

    const ceRsi = ind0916MinCe.rsi5m;
    const peRsi = ind0916MaxPe.rsi5m;
    
    if (ceRsi == null || peRsi == null) return null;

    let bullScore = 0;
    let bearScore = 0;

    if (ceRsi >= 80) bearScore++;
    if (ceRsi <= 30) bullScore++;
    if (peRsi >= 80) bullScore++;
    if (peRsi <= 30) bearScore++;

    let status = 'Sideways';
    
    if (bullScore > bearScore) {
        status = 'Bull';
    } else if (bearScore > bullScore) {
        status = 'Bear';
    } else if (bullScore > 0 && bearScore > 0 && bullScore === bearScore) {
        status = 'Sideways';
    } else {
        const diff = ceRsi - peRsi;
        if (diff > 5) status = 'Bull';
        else if (diff < -5) status = 'Bear';
    }

    if (status === 'Sideways') return null;

    // Use Top 1 ITM strike as entry, fallback to ATM
    let entryStrike = top1?.strike;
    if (!entryStrike) {
        const spot = data.spotPrice || 0;
        if (spot <= 0) return null;
        entryStrike = Math.round(spot / context.gap) * context.gap;
    }

    const liveRawOptsArr = context.chain || [];
    const liveFlatOpts = ensureFlatOpts(liveRawOptsArr);

    const optionType = status === 'Bull' ? 'CE' : 'PE';
    const atmRow = liveFlatOpts.find((r: any) => r.strike === entryStrike && r.type === optionType);
    
    if (atmRow) {
        let entryPrice = atmRow.ltp || atmRow.close || atmRow.price || 0;
        if (entryPrice > 0) {
            return {
                trade_type: status === 'Bull' ? 'BULL' : 'BEAR',
                strike: entryStrike,
                option_type: optionType,
                entry_price: entryPrice,
                remarks: `RSI Divergence (CE:${Math.round(ceRsi)} PE:${Math.round(peRsi)})`
            };
        }
    }

    return null;
};
